module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty20.586b0359.jpg";